<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DWRMdV/tc-custom/9781590209103.jpg?1721057645055" alt="This image is the cover for the book Job"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Job
      </h1>
      <p class="bookDescription body article font2">
        <b>An Orthodox Jew’s faith is tested when he leaves Tsarist Russia for NYC in this retelling of the Book of Job—“inspired in its poetry and its deep insight” (The New York Times).</b><br/><br/><i>Job</i> is the tale of Mendel Singer, a pious Eastern-European Jew who teaches the Torah to children, and whose faith is tested at every turn. His youngest son seems to be incurably disabled, one of his older sons joins the Russian Army, the other deserts to America, and his daughter is running around with a Cossack. When he flees with his wife and daughter, further blows of fate await him . . .<br/><br/> <br/><br/>In this modern fable based on the biblical story of Job, Mendel Singer witnesses the collapse of his world, experiences unbearable suffering and loss, and ultimately gives up hope and curses God, only to be saved by a miraculous reversal of fortune.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Roth
      </h2>
      
      <p class="authorDescription body article">Joseph Roth was born in 1894 in a small Galician town on the eastern borders of the Hapsburg Empire. After serving in the Austro-Hungarian army from 1916 to 1918, he worked as a journalist in Vienna and in Berlin. He died in Paris in 1939, leaving behind thirteen novels as well as many stories and essays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?506d30eb